import { render, staticRenderFns } from "./createOrk.vue?vue&type=template&id=135e54fa&"
import script from "./createOrk.vue?vue&type=script&lang=js&"
export * from "./createOrk.vue?vue&type=script&lang=js&"
import style0 from "./createOrk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports